// extracted by mini-css-extract-plugin
export default {"header":"MockWorkQ_header__0HE3F","header_cell":"MockWorkQ_header_cell__nHBIi"};